import { Pipe, PipeTransform } from '@angular/core';

const dayDivider = 1000 * 60 * 60 * 24;

@Pipe({
  name: 'afterXDays',
  standalone: true,
})
export class AfterXDaysPipe implements PipeTransform {
  transform(value?: Date | string): number {
    if (!value) {
      return -1;
    }
    if (!(value instanceof Date)) {
      value = new Date(value);
    }

    const now = new Date();
    if (
      now.getFullYear() === value.getFullYear() &&
      now.getMonth() === value.getMonth() &&
      now.getDate() === value.getDate()
    ) {
      return 0;
    }

    return (
      Math.floor(value.getTime() / dayDivider) -
      Math.floor(now.getTime() / dayDivider)
    );
  }
}

@Pipe({
  name: 'afterXDaysString',
  standalone: true,
})
export class AfterXDaysStringPipe implements PipeTransform {
  transform(value?: number): string {
    if (value === -1) {
      return '';
    }

    if (value === 0) {
      return 'today';
    } else if (value === 1) {
      return 'tomorrow';
    }

    return `in ${value} days`;
  }
}
